// extracted by mini-css-extract-plugin
module.exports = {"about_us_container":"about-partsavatar_about_us_container__l6uwQ"};